<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Submit'"
  >
    <template slot="header">
      <span>Add {{ inventoryClassName }}Pick List Item</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col v-if="isCreatingFromTruckScheduleRequest" class="pb-0">
          <inventory-class-select-element
            v-model="inventoryClassId"
            :is-required="true"
            :is-add-all="false"
            :is-railings="false"
            :is-glass="false"
            :is-vwd-glass="false"
            :is-panels="false"
            :is-sid="false"
            :is-rail-part="false"
            :is-paint="false"
            :is-equipment="false"
            :is-patio-door="false"
            :is-euro-door="false"
            :is-medical-aid="false"
          />
        </v-col>
      </v-row>
      <v-row v-if="item">
        <v-col>
          <v-row>
            <v-col
              class="pb-0"
            >
              <v-autocomplete
                v-model="item.inventory_tag"
                label="QR Code"
                :items="qrCodes"
                :item-text="item => `${item.inventory_tag} - ${item.item_full_name}`"
                item-value="inventory_tag"
                clearable
                :single-select="false"
                :loading="loadingQrCodes"
                :rules="[(v) => !!v || 'QR Code is required']"
                :disabled="inventoryClassId === null || loadingQrCodes"
              >
                <template #selection="{ item }">
                  <span><span v-if="!isCreatingFromTruckScheduleRequest" style="font-weight: bold;">{{ item.inventory_tag ? `${item.inventory_tag} -` : '' }}</span> {{ item.item_full_name ? item.item_full_name : '' }}</span>
                </template>
                <template #item="{ item }">
                  <span><span v-if="!isCreatingFromTruckScheduleRequest" style="font-weight: bold;">{{ item.inventory_tag ? `${item.inventory_tag} -` : '' }}</span> {{ item.item_full_name ? item.item_full_name : '' }}; <span style="color: green;"> UOM: {{ item.uom ? item.uom.name : '' }} </span>; <span style="color: blue;">Qty On Hand: {{ item.quantity_on_hand ? item.quantity_on_hand : '' }}</span></span>
                </template>
                <template v-if="loadingQrCodes" #label>
                  Loading Items...
                </template>
                <template v-else #label>
                  {{`${isCreatingFromTruckScheduleRequest ? 'Inventory Item' : 'QR Code'}`}}<RedAsterisk />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="6">
              <span :style="{ color: isDarkMode ? '' : '#000000', fontSize: '16px' }">Quantity On Hand: {{ item.quantity_on_hand }}</span>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="item.quantity_required"
                type="number"
              >
                <template #label>
                  Quantity Required<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {
    // isInst: {
    //   type: Boolean,
    //   default: false,
    // },
    isCreatingFromTruckScheduleRequest: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      inventory_tag: null,
      inventory_tag_item: null,
      quantity_required: null,
      quantity_on_hand: null,
    },
    inventoryClassId: null,
    loadingQrCodes: false,
    qrCodes: [],
    inventoryClassId4500: 1,
    inventoryClassId4800: 2,
    inventoryClassIdInst: 4,
    inventoryClassIdCommercial: 6,
    inventoryClassIdParts: 11,
    departmentIdInstallation: 49,
  }),
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([

    ]),
    is4500() {
      return this.inventoryClassId === this.inventoryClassId4500;
    },
    is4800() {
      return this.inventoryClassId === this.inventoryClassId4800;
    },
    isInst() {
      return this.inventoryClassId === this.inventoryClassIdInst;
    },
    isCommercial() {
      return this.inventoryClassId === this.inventoryClassIdCommercial;
    },
    isParts() {
      return this.inventoryClassId === this.inventoryClassIdParts;
    },
    inventoryClassName() {
      if (this.isCreatingFromTruckScheduleRequest) {
        return '';
      }
      if (this.is4500) {
        return '4500 ';
      }
      if (this.is4800) {
        return '4800 ';
      }
      if (this.isInst) {
        return 'Installation Material ';
      }
      if (this.isCommercial) {
        return 'Commerical ';
      }
      if (this.isParts) {
        return 'Parts ';
      }
      return '';
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'item.inventory_tag': function (val) {
      const item = this.qrCodes.find((x) => x.inventory_tag === val);
      if (item) {
        this.item.quantity_on_hand = item.quantity_on_hand;
        this.item.inventory_tag_item = item;
      }
    },

    inventoryClassId() {
      if (this.isCreatingFromTruckScheduleRequest) {
        this.getQrCodes();
      }
    },
  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async submit() {
      this.$emit('success', this.item);
      return true;
    },

    async open(item, itemIndex, inventoryClassId) {
      this.inventoryClassId = inventoryClassId;
      this.$refs.dialogBox.open();
      const res = await this.getQrCodes();
      if (item) {
        this.item = JSON.parse(JSON.stringify(item));
        this.item.quantity_on_hand = this.qrCodes.find((x) => x.inventory_tag === item.inventory_tag).quantity_on_hand;
      } else {
        this.item = { ...this.itemDto };
      }
      if (itemIndex) {
        this.item.index = itemIndex;
      }
    },

    async getQrCodes() {
      this.loadingQrCodes = true;
      if (this.isCreatingFromTruckScheduleRequest && this.inventoryClassId === null) {
        this.loadingQrCodes = false;
        return;
      }
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
          is_qty_on_hand_o: 1,
        },
      };
      if (this.inventoryClassId === this.inventoryClassIdInst) {
        readModel.filters.department_id = this.departmentIdInstallation;
      }
      const res = await this.$api.inventoryTag.readData(readModel);

      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loadingQrCodes = false;
      if (!res || !res.data || res.data.length === 0) {
        this.qrCodes = [];
        return;
      }
      this.qrCodes = res.data;
    },
  },
};
</script>
